import Vue       from 'vue'
import Router    from 'vue-router'
import axios     from 'axios'
import VueAxios  from 'vue-axios'
import loginView from '@/components/Login_View'
import registerUserView from '@/components/Register_user'
import verificarEmailView from '@/components/Verificar_email'
import forgotPassword from '@/components/Forgot_password_request'
import forgotPasswordPostView from '@/components/View_Forgot_Password_Post'
import Notifications from 'vue-notification'

Vue.use(Notifications)
Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL = process.env.API_ROUTE

export default new Router({
  mode: 'history',
  routes: [
    {
      path     : '/register',
      name     : 'register',
      component: registerUserView
    },
    {
      path     : '/',
      name     : 'login',
      component: loginView
    },
    {
      path     : '/forgot-password-request',
      name     : 'forgot-password',
      component: forgotPassword
    },
    {
      path     : '/forgot-password-post',
      name     : 'forgot-password-post',
      component: forgotPasswordPostView
    },
    {
      path     : '/profile-activate',
      name     : 'profile-activate',
      component: verificarEmailView
    },
    {
      path     : '/*',
      name     : '404',
      component: loginView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/not_logged.js